import { Automation } from '../types';

export const ACTION_TYPES = {
  SET_AUTOMATION_LIST: 'SET_AUTOMATION_LIST',
};

interface AutomationState {
  automations: Automation[];
  hasUnsavedChanges: boolean;
}

export interface AutomationAction {
  type: string;
  payload: {
    automations: Automation[];
    hasUnsavedChanges: boolean;
  };
}

export const automationReducer = (state: AutomationState, action: AutomationAction) => {
  switch (action.type) {
    case ACTION_TYPES.SET_AUTOMATION_LIST:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
